module.exports = __webpack_public_path__ + "img/result-02.e74e9d0e.svg";